import { apiQuery } from '../';

export const outreachApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getOutreach: builder.query({
        query: ({ outreachId }) => {
          return {
            method: 'get',
            url: `/outreaches/${outreachId}`,
          };
        },
        transformResponse: (response) => response.data,
      }),

      createOutreach: builder.mutation({
        transformResponse: (response) => response.data,
        query: (outreach) => {
          return {
            url: '/outreaches',
            method: 'post',
            data: { outreach },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useGetOutreachQuery, useCreateOutreachMutation } = outreachApi;
